module.exports = __webpack_public_path__ + "static/img/news021.afd97749.png";